import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getToken, base_url } from "../../config/config";

const InvoiceList = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const response = await fetch(`${base_url}/v1/getInvoiceTemplate`);
      const data = await response.json();
      setTemplates(data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTemplateClick = (templateId) => {
    navigate(`/invoice/edit/${templateId}`);
  };

  const handleNewInvoice = () => {
    navigate("/invoice/new");
  };

  return (
    <div className='min-h-screen bg-gray-50 py-8'>
      <div className='max-w-4xl mx-auto px-4'>
        <div className='flex justify-between items-center mb-8'>
          <h1 className='text-2xl font-bold text-gray-900'>
            Invoice Templates
          </h1>
          <button
            onClick={handleNewInvoice}
            className='px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600'>
            Create New Invoice
          </button>
        </div>

        {loading ? (
          <div className='text-center py-8'>Loading...</div>
        ) : (
          <div className='grid gap-4'>
            {templates.map((template) => (
              <div
                key={template._id}
                onClick={() => handleTemplateClick(template._id)}
                className='bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer border border-gray-200'>
                <div className='flex justify-between items-center'>
                  <div>
                    <h3 className='text-lg font-semibold text-gray-900'>
                      {template.name}
                    </h3>
                    <p className='text-sm text-gray-500'>
                      Last modified:{" "}
                      {new Date(template.updatedAt).toLocaleDateString()}
                    </p>
                  </div>
                  <div className='flex items-center space-x-2'>
                    <span className='text-sm text-gray-500'>Click to edit</span>
                    <svg
                      className='w-5 h-5 text-gray-400'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      viewBox='0 0 24 24'
                      stroke='currentColor'>
                      <path d='M9 5l7 7-7 7' />
                    </svg>
                  </div>
                </div>
              </div>
            ))}

            {templates.length === 0 && (
              <div className='text-center py-8 bg-white rounded-lg border border-gray-200'>
                <p className='text-gray-500'>No templates found</p>
                <button
                  onClick={handleNewInvoice}
                  className='mt-4 px-4 py-2 text-blue-500 hover:text-blue-600'>
                  Create your first invoice
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoiceList;
